export default "__VITE_ASSET__UBWJv2Th__"